import type { IconSvgObject } from './types';

const RepostIcon: IconSvgObject = [
  ["path", { d: "M8.5 15L5 18.5L8.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.5 18.5L19 18.5C20.1046 18.5 21 17.6046 21 16.5L21 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.5 2L19 5.5L15.5 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18.5 5.5L5 5.5C3.89543 5.5 3 6.39543 3 7.5L3 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default RepostIcon;
